import React, { useContext, useState, useEffect } from 'react'
import PrimaryButton from '../../../product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthContext from '../../../product/context/auth/authContext'
import UserContext from '../../../product/context/user/userContext'
import { Accordion, AccordionDetails, AccordionSummary, Button, Link } from '@material-ui/core'
// import AddressDetails from '../../../custom/components/organisms/Address'
import CustomDialog from '../../../product/components/organisms/Dialog'
import SecondaryButton from '../../../product/components/atoms/SecondaryButton'
import AlertContext from '../../../product/context/alert/alertContext'
import PhoneValidationComponent from '@/product/components/species/components/user/PhoneValidationComponent'
import EmailValidationComponent from '@/product/components/species/components/user/EmailValidationComponent'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import Cryptos from '../../../product/common/cryptos'
import {
    handleRedirectInternal,
    mapData,
    formatPhone,
    formatDate,
} from '../../../product/common/components'
import productContext from '@/product/context/product/productContext'
import CommonContext from '../../../product/context/common/commonContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { Description, InsertDriveFile, PictureAsPdf } from '@material-ui/icons'

const ProfileComponent = () => {
    const authContext = useContext(AuthContext)
    const { setAlert } = useContext(AlertContext)
    const userContext = useContext(UserContext)
    const commonContext = useContext(CommonContext)
    const productCommonContext = useContext(productContext)
    const history = useHistory()
    const {
        uploadImage,
        uploadedFiles,
        allNotifications,
        configFeatures,
        allCountries,
        allStates,
    } = commonContext
    const { isAuthenticated, user, loadUser } = authContext
    const { updateProfile, updatePreference, responseStatus: responseStatusUser } = userContext
    const [phoneVerify, setPhoneVerify] = React.useState(false)
    const [address, setAddress] = useState([])
    const [phonePopup, setPhonePopup] = useState(false)
    const [uploadedFile, setUploadedFile] = useState(null)
    const [fileUrl, setFileUrl] = useState('')
    const [files, setFiles] = useState([])
    const [emailVerify, setEmailVerify] = useState(false)
    const changeEmailVerify = () => {
        setEmailVerify(!emailVerify)
    }
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        data: null,
    })
    const toggleFullScreenPopup = (popup, status, data) => {
        setManage({ popup, status, data })
    }
    const setUserAddress = () => {
        setAddress(user.address_details.filter((inner) => inner.status === 'active'))
        toggleFullScreenPopup(false, 'new', null)
    }
    useEffect(() => {
        if (isAuthenticated) {
            setUserAddress()
        }
    }, [isAuthenticated, user && user.address_details])
    const [currentCountry, setCurrentCountry] = useState()
    const formatPhone = (phone, removeCountryCode = false) => {
        const countryCode = '+1'
        if (
            removeCountryCode &&
            (phone === '+1' ||
                phone === '1' ||
                phone === '+' ||
                phone === '' ||
                phone === null ||
                phone === '+10' ||
                phone === '0')
        ) {
            phone = ''
        } else if (removeCountryCode && typeof phone === 'string' && phone?.length) {
            const regex = /\d+/g
            phone = phone.replace(/^\+?1\s?/, '')
            phone = phone.replace(/^\+/, '')
            const numbersArray = phone?.match(regex)
            const numbersString = numbersArray?.join('')
            phone = parseInt(numbersString, 10)
        } else {
            if (typeof phone === 'string' && !phone?.startsWith('+1')) {
                phone = `${countryCode}${phone}`
            } else {
                phone = `${countryCode}${phone || ''}`
            }
        }
        return phone
    }
    const validationArrayTaxes = Yup.object({
        companyname: Yup.string().when('tax_number', {
            is: (tax_number) => tax_number && tax_number.length > 0 && tax_number !== '',
            then: Yup.string().required('Required!'),
        }),
        tax_number: Yup.string().required('Required!'),
        // resale_certificate: Yup.array().when('tax_number', {
        //     is: (tax_number) => tax_number && tax_number.length > 0 && tax_number !== '',
        //     then: Yup.array().required('Required!'),
        // }),
    })
    const formikTaxes = useFormik({
        initialValues: {
            id: '',
            companyname: '',
            resale_certificate: [],
            tax_number: '',
        },
        validationSchema: validationArrayTaxes,
        onSubmit: (values) => {
            let value = values
            if (files.length) {
                values.resale_certificate = files

                if (value.tax_number == '') {
                    value.tax_doc_status = 0
                }
                if (value.tax_number !== user.tax_number) {
                    value.tax_doc_status = 0
                }

                if (
                    values.resale_certificate != user.resale_certificate &&
                    values.resale_certificate?.length
                ) {
                    values.sendAdminNotification = true
                    values.sendAdminNotification_type = ['tax_doc_update']
                }
                if (value.tax_number !== user.tax_number) {
                    value.tax_doc_status = 0
                    values.sendAdminNotification = true
                    values.sendAdminNotification_type = ['tax_doc_update']
                }

                updateProfile(value, true, 'resale_update')
            } else {
                setAlert('Please upload tax document', 'error')
            }
        },
    })
    const validationArray = Yup.object({
        first_name: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z]*$/g, 'The special characters not allowed')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        last_name: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z]*$/g, 'The special characters not allowed')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        username: Yup.string().max(250, 'Maximum 250 characters').required('Required'),
        phone: Yup.string()
            .trim()
            .min(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .max(10, (obj) => {
                if (obj?.value?.length) {
                    return 'Phone must be 10 digits'
                }
            })
            .required('Required'),
        additional_phone: Yup.string()
            .trim()
            .transform((value) => (value === '' || value === '+1' ? null : value))
            .nullable()
            .min(10, (obj) => {
                if (obj.value) return 'Phone must be 10 digits'
            })
            .max(10, (obj) => {
                if (obj.value) return 'Phone must be 10 digits'
            })
            .when('phone', {
                is: (value) => value?.length === 10,
                then: Yup.string()
                    .nullable()
                    .notOneOf(
                        [Yup.ref('phone')],
                        'Mobile number and additional phone number should not be same',
                    ),
            }),
        email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        address1: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Some kind of special characters not allowed')
            .max(250, 'Maximum 250 characters')
            .nullable(),
        apt_unit: Yup.string().trim().nullable(),
        city: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
            .nullable(),
        state: Yup.string().trim().nullable(),
        country: Yup.string().trim().nullable(),
        zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive number only')
            .max(6, 'Maximum 6 characters')
            .nullable(),
        find_source: Yup.string().nullable().trim(),
    })
    const formik = useFormik({
        initialValues: {
            id: '',
            first_name: '',
            last_name: '',
            phone: '',
            additional_phone: '',
            email: '',
            address1: '',
            apt_unit: '',
            city: '',
            state: global.defaultState,
            country: global.defaultCountry,
            zip: '',
            find_source: '',
            isVerifyPhone: true,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            let value = values
            if (value.email_verified === 1 && value.verified_email === value.email) {
                if (
                    true ||
                    (value.phone_verified === 1 && value.verified_phonenum == value.phone) ||
                    value.phone === '+1'
                ) {
                    if (value.first_name) values.first_name = values.first_name.trim()
                    if (value.last_name) values.last_name = values.last_name.trim()

                    if (value.phone) {
                        value.phone = formatPhone(value.phone)
                    }

                    if (value.additional_phone) {
                        value.additional_phone = formatPhone(value.additional_phone)
                    }

                    updateProfile(value)
                } else {
                    setPhonePopup(true)
                }
            } else {
                setEmailVerify(true)
            }
        },
    })

    useEffect(() => {
        if (user) {
            formik.values.id = user.id || ''
            formikTaxes.values.id = user.id || ''
            formik.values.first_name = user.first_name || ''
            formik.values.last_name = user.last_name || ''
            formik.values.email = user.email || ''
            formik.values.username = user.username || ''
            formik.values.phone = formatPhone(String(user.phone), true) || ''
            setFiles(user.resale_certificate ? [user.resale_certificate] : [])

            formik.values.additional_phone = formatPhone(String(user.additional_phone), true) || ''

            formikTaxes.values.companyname = user.companyname || ''
            formikTaxes.values.resale_certificate = user.resale_certificate
                ? [user.resale_certificate]
                : []
            formikTaxes.values.tax_number = user.tax_number || ''

            formik.values.country = user.country ? user.country : global.defaultCountry
            formik.values.state = user.state ? user.state : global.defaultState
            formik.values.address1 = user.address1
            formik.values.apt_unit = user.apt_unit
            formik.values.find_source = user.find_source

            formik.values.city = user.city
            formik.values.zip = user.zip
            formik.values.phone_verified = user?.phone_verified === 1 ? 1 : 0
            formik.values.verified_phonenum =
                user?.phone && user?.phone_verified === 1 ? formatPhone(user.phone, true) : ''

            formik.values.email_verified = 1
            formik.values.verified_email = user.email ? user.email : ''
            formik.setTouched({})
            formikTaxes.setTouched({})
        }
    }, [user])
    const generateAsterisks = () => {
        if (formik.values.driver_license) {
            return '*'.repeat(formik.values.driver_license.length)
        } else {
            return '*'.repeat(5)
        }
    }
    function padNumber(number) {
        let numberString = number?.toString()
        let zerosToAdd = Math.max(0, 6 - numberString?.length)
        let paddedNumber = '0'.repeat(zerosToAdd) + numberString

        return paddedNumber
    }
    const taxes = [
        {
            type: 'misc',
            content: (
                <h4 style={{ fontSize: '14px' }} className="mt-2">
                    Please contact us to receive a tax exempt form. Submit completed forms to
                    support@zipperbuy.com or upload a copy below.
                </h4>
            ),
            class: `col-12 mb-3 pl-0`,
        },
        {
            label: 'Company Name',
            name: 'companyname',
            type: 'text',
            placeholder: 'Enter company name',
            class: 'col-12 col-sm-6 pl-0 paxsecondFld',
        },
        {
            label: 'Tax ID Number',
            name: 'tax_number',
            type: 'text',
            placeholder: 'Enter tax id number',
            class: 'col-12 col-sm-6 paxsecondFld',
        },
        // {
        //     type: 'uploadDropZone',
        //     name: 'resale_certificate',
        //     icon: 'picture_as_pdf',
        //     titleText: 'Upload Tax Exempt Form',
        //     class: 'col-12 col-sm-6',
        //     folder: 'docs',
        //     multiple: true,
        //     accept: 'image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        // },
    ]
    const profile = [
        {
            type: 'misc',
            content: 'Contact Information',
            class: 'col-12 col-sm-12 mb-3 sectionLabel',
        },
        {
            label: 'First Name',
            name: 'first_name',
            type: 'text',
            placeholder: 'Enter your first name',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Last Name',
            name: 'last_name',
            type: 'text',
            placeholder: 'Enter your last name',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Mobile Phone Number',
            name: 'phone',
            type: 'number',
            placeholder: 'Enter your mobile phone number',
            countryCodeEditable: false,
            class: 'col-12 col-sm-6',
            tooltiptitle: 'Please enter the mobile phone number without the country code.',
            disableHoverListener: false,
        },
        {
            label: 'Secondary Phone',
            name: 'additional_phone',
            type: 'number',
            placeholder: 'Enter your secondary phone',
            countryCodeEditable: false,
            class: 'col-12 col-sm-6',
            tooltiptitle: 'Please enter the phone number without the country code.',
            disableHoverListener: false,
        },
        {
            label: 'Email',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email',
            disabled: true,
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Username',
            name: 'username',
            type: 'text',
            placeholder: 'Enter your username',
            class: 'col-12 col-sm-6',
        },
        {
            type: 'misc',
            content: <hr />,
            class: `col-12 sectionLine my-3`,
        },
        {
            type: 'misc',
            content: 'Billing Address',
            class: 'col-12 col-sm-12 mb-3 sectionLabel',
        },
        {
            label: 'Address',
            name: 'address1',
            type: 'text',
            placeholder: 'Enter your address',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Apt or Unit',
            name: 'apt_unit',
            type: 'text',
            placeholder: 'Enter your apt or unit',
            class: 'col-12 col-sm-6',
        },
        {
            label: 'City',
            name: 'city',
            type: 'text',
            placeholder: 'Enter your city',
            class: 'col-12 col-sm-6',
        },

        {
            label: 'State',
            placeholder: 'Select your state',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formik.values.country
                            ? formik.values.country.indexOf(state.countryCode) !== -1
                            : global.defaultCountry.indexOf(state.countryCode) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1,
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'state',
        },

        {
            label: 'Country',
            placeholder: 'Select your country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter((country) => global.ignoreCountry.indexOf(country.isoCode) === -1)
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'country',
        },

        {
            label: 'Zip code',
            placeholder: 'Enter your zip code',
            class: 'col-12 col-sm-6',
            type: 'text',
            name: 'zip',
        },
        {
            type: 'misc',
            content: <hr />,
            class: `col-12 sectionLine my-3`,
        },
        {
            label: 'How Did You Find Us?',
            placeholder: 'Select',
            class: 'col-12 col-sm-6 howFind',
            type: 'select',
            options: [
                { show: 'Facebook', value: 'Facebook' },
                { show: 'Instagram', value: 'Instagram' },
                { show: 'Twitter', value: 'Twitter' },
                { show: 'Google', value: 'Google' },
                { show: 'Staff Member', value: 'Staff Member' },
                { show: 'Word of Mouth', value: 'Word of Mouth' },
                { show: 'Other', value: 'Other' },
            ],
            name: 'find_source',
        },
    ]
    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'updatePreference'
            ) {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                    //formikChange.resetForm()
                }
            }
            if (responseStatusUser.from == 'resale_update') {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                    setAlert('Tax Updated Successfully', 'success')
                    //formikChange.resetForm()
                } else {
                    setAlert(responseStatusUser.message, 'error')
                }
            }
        }
    }, [responseStatusUser])
    useEffect(() => {
        setCurrentCountry(formik.values.country)
        if (user && user.country && formik.values.country === user.country) {
            formik.setFieldValue('state', user.state)
        } else {
            formik.setFieldValue('state', '')
        }
    }, [formik.values.country])
    const changePhoneVerify = () => {
        setPhonePopup(!phonePopup)
    }
    const cancelFunction = () => {
        setPhonePopup(false)
        formik.handleReset()
    }
    const profileUpdate = () => {
        // updateProfile(formik.values)
        formik.submitForm()
    }
    const handleFileUpload = (event) => {
        const uploadedFiles = Array.from(event.target.files)
        let arr = uploadedFiles.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
            }),
        )
        var formData = new FormData()
        formData.append('folder', 'tax_file')

        arr.forEach((value, key) => {
            formData.append('file_upload', value)
        })
        uploadImage(formData, 'tax_certificate')
    }

    const getFileExtension = (file) => {
        let fileExtent = /[.]/.exec(file) ? /[^.]+$/.exec(file) : undefined
        if (fileExtent && fileExtent.length) {
            return fileExtent[0]
        } else {
            return ''
        }
    }
    const getFileIcon = (type) => {
        if (getFileExtension(type) == 'pdf')
            return <FontAwesomeIcon icon={faFilePdf} style={{ color: 'red', fontSize: '26px' }} />
        if (
            getFileExtension(type) == 'word' ||
            getFileExtension(type) == 'doc' ||
            getFileExtension(type) == 'msword'
        )
            return <Description style={{ fill: 'blue', fontSize: '32px' }} />
    }

    useEffect(() => {
        if ('tax_certificate' === uploadedFiles.from && uploadedFiles.files.length) {
            setFiles([uploadedFiles.files[0].filename])
        }
    }, [uploadedFiles])
    return (
        <>
            <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                <div className="accChild" style={{ position: 'relative' }}>
                    <div className="row">{mapData({ formik: formik, data: profile })}</div>
                </div>
                <PrimaryButton
                    type="submit"
                    label="Update Information"
                    id="saveprofile_button"
                    className="saveProfile"
                />
            </form>
            <div className="accChild taxChild my-4">
                <form onSubmit={formikTaxes.handleSubmit} autoComplete="nofill">
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Tax Exempt (if applicable)
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="row">
                                {mapData({ formik: formikTaxes, data: taxes })}
                                <PrimaryButton
                                    type="button"
                                    onClick={() => formikTaxes.handleSubmit()}
                                    label="Submit Tax Exempt Request"
                                    id="savetax_button"
                                    className="saveProfile mt-0"
                                />
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <input
                        type="file"
                        id="fileInput"
                        className="d-none"
                        multiple
                        accept=".docx,.pdf"
                        // accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        onChange={handleFileUpload}
                    />
                    <div className="row">
                        <div
                            className="col-sm-6 col-12 d-flex align-items-center"
                            style={{ gap: '20px' }}
                        >
                            <PrimaryButton
                                type="button"
                                label="Contact Us"
                                className="w-100"
                                onClick={() => handleRedirectInternal(history, 'contact-us')}
                            />
                            <PrimaryButton
                                type="button"
                                label="Upload"
                                className="w-100"
                                id="saveprofileUpload_button"
                                onClick={() => document.getElementById('fileInput').click()}
                            />
                            <ul className="filesList d-flex mb-0 pl-0 align-items-center">
                                {files.map((file, index) => (
                                    <li key={index} className="file-item">
                                        <a
                                            href={`${process.env.REACT_APP_DOMAIN}/uploads/tax_file/${file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="badge p-2"
                                        >
                                            {getFileIcon(file)}
                                        </a>
                                    </li>
                                ))}
                            </ul>

                            {/* <InsertDriveFile style={{ fill: 'blue', fontSize: '30px' }} /> */}
                        </div>
                    </div>
                </form>
            </div>
            <PhoneValidationComponent
                phoneVerify={phonePopup}
                formik={formik}
                setPhoneVerify={setPhonePopup}
                changePhoneVerify={changePhoneVerify}
                verifyStatusChange={false}
                profileUpdate={profileUpdate}
                includeCountryCode={'+1'}
                showContactUs={true}
                contactUsLink={'/contact-us'}
                checkTerms={true}
                contactUsText={'Contact Us'}
            />

            <EmailValidationComponent
                emailVerify={emailVerify}
                formik={formik}
                setEmailVerify={setEmailVerify}
                changeEmailVerify={changeEmailVerify}
                verifyStatusChange={false}
                noToken={true}
                profileUpdate={profileUpdate}
            />
        </>
    )
}

export default ProfileComponent
